import { Navigate, useSearchParams } from "react-router-dom";
import { notificationsPagePath } from "../lib/notificationsRoutes";

/** Old notification links used `/notifications?jobPostId=…` before role-scoped routes. */
export default function LegacyNotificationsRedirect({ role }) {
  const [searchParams] = useSearchParams();
  const base = notificationsPagePath(role);
  const query = searchParams.toString();
  return <Navigate to={query ? `${base}?${query}` : base} replace />;
}
